import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import MSIcon from '@/assets/icons/ms-icon.svg?react';
import TopNav from '@/components/top-nav';
import { Button } from '@/components/ui/button';
import useAuth from '@/hooks/use-auth';
import useSignIn from '@/hooks/use-sign-in';

const SignInPage = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const { mutate: signInUser } = useSignIn();

  const onHandleSignIn = () => signInUser();

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="h-screen flex items-center justify-center bg-white">
      <TopNav visibility={false} />
      <div className="flex flex-col items-center gap-6">
        <div className="font-inter font-semibold text-xl text-center text-foreground">
          {t('auth.sign_in.title')}
        </div>
        <div className="font-normal text-sm text-center text-muted-foreground">
          {t('auth.sign_in.subtitle')}
        </div>
        <Button
          onClick={onHandleSignIn}
          className="w-[218px] h-10 rounded-lg bg-background border border-border shadow-sm py-2 px-5 flex justify-center items-center gap-2"
        >
          <MSIcon className="size-6" />
          <span className="text-foreground text-md">{t('auth.sign_in.with_microsoft')}</span>
        </Button>
      </div>
    </div>
  );
};

export default SignInPage;
